import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import { Box } from "@bca/ui-library";

import StyledIcon from "../Interfaces/StyledIcon";

const KeySvg: React.FunctionComponent<StyledIcon> = ({
  fill = "primary-navy-blue",
  width = 22,
  height = 22,
  ...props
}) => {
  const theme = useContext(ThemeContext);
  const hexColor = theme.colors[fill] || fill;
  return (
    <Box {...props} color="black">
      <title>Key Icon</title>
      <svg
        width={width}
        height={height}
        viewBox="0 0 23 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.5 7.60547C22.5 3.39453 19.1055 0 14.8945 0C10.7266 0.0429688 7.375 3.39453 7.375 7.5625C7.375 8.42188 7.50391 9.19531 7.71875 9.96875L0.800781 16.8867C0.585938 17.1016 0.5 17.3594 0.5 17.6172V20.9688C0.5 21.5703 0.929688 22 1.53125 22H6.34375C6.90234 22 7.375 21.5703 7.375 20.9688V19.25H9.09375C9.65234 19.25 10.125 18.8203 10.125 18.2188V16.5H11.7148C12.0156 16.5 12.2734 16.3711 12.4883 16.1562L13.5195 14.9961C13.9492 15.082 14.4219 15.125 14.9375 15.125C19.1055 15.125 22.5 11.7734 22.5 7.60547ZM14.9375 5.5C14.9375 4.38281 15.8398 3.4375 17 3.4375C18.1172 3.4375 19.0625 4.38281 19.0625 5.5C19.0625 6.66016 18.1172 7.5625 17 7.5625C15.8398 7.5625 14.9375 6.66016 14.9375 5.5Z"
          fill={hexColor}
        />
      </svg>
    </Box>
  );
};

export default KeySvg;
